<template>
  <div>
    <v-card
      style="border-top-left-radius: 30px; border-bottom-right-radius: 20px"
      elevation="10"
      class="p-3"
    >
      <b-loading :active.sync="loading" />
      <!-- <div class="w-full flex justify-between items-start">
      <Lynx-Title text="Gerenciamento de Arquivos Notafiscal"/>

      <div class="flex flex-row-reverse items-end mb-4">
        <b-button class="is-primary ml-4" icon-right="refresh"
                  @click.native="() => {fetchNotafiscal(); fetchUploadReport()}">Atualizar Lista
        </b-button>
       
      </div>
    </div> -->

      <div class="w-full flex justify-between">
        <Lynx-Title text="Nota Fiscal" />

        <div class=" items-end">

        {{emite_nf ? 'Emite com ServiceTech' : 'Não emite com ServiceTech'}}
          <b-switch
          v-model="emite_nf"
          :true-value="1" :false-value="0"
          @input="emitir_nf"
          />
          </div>
      
      </div>

      <div class="flex flex-row-reverse items-end">
          
          
          <b-button class="is-warning" @click.native="() => reletorio()"
            >Gerar Relatório
            <b-icon icon="file" class="ml-1"></b-icon>
          </b-button>
          <b-button
            class="is-primary mr-1"
            @click.native="() => showModal('criar')"
            >Criar
            <b-icon icon="file" class="ml-1"></b-icon>
          </b-button>
      
        <div class="flex justify-start w-2/3">
          <label class="">
            <Lynx-Label label="Emissão" />
            <b-datepicker
              type="month"
              placeholder="Selecione a data de competência"
              icon="calendar-today"
              :month-names="monthNames"
              v-model="dataCompetencia"
              @input="filter_competecia"
            />
          </label>
        </div>
      </div>
      <div class=" ">
          <span class="p-1 mt-3 mb-3 float-right" style="font-weight: 500; border: 1px solid black"
            >Valor Total R$ {{ valor_total | money }}</span
          >
        </div>
      <div class="">
        
     
        <b-table
          :data="notasfiscais"
          :columns="columns"
          :paginated="true"
          default-sort-direction="asc"
          default-sort="id"
          per-page="10"
          style="font-size: 11px"
          class=""
          narrowed
          bordered
        >
          <template slot-scope="props">
            <!-- <b-table-column field="id" v-text="props.row.empresas_id"/> -->
            <!-- <b-table-column field="tipo" >
        {{ props.row.tipo.replace('_',' ') }}
        </b-table-column> -->
            <b-table-column style="width: 10px;" width="10" field="numero_nota_fiscal">
              {{ props.row.tomador.numero_nota_fiscal }}</b-table-column
            >
            <b-table-column field="criacao">
              {{ props.row.created_at | formatEnToBr }}</b-table-column
            >
            <b-table-column field="tomadores_id">
              <span>{{  props.row.tomador.cnpj_tomador  }}</span></b-table-column
            >
         
            <b-table-column field="emissao">
              {{ props.row.tomador.data_emissao | formatEnToBr }}</b-table-column
            >
            <b-table-column field="data_competencia">
              {{ props.row.tomador.data_competencia | formatEnToBr }}</b-table-column
            >


            <b-table-column field="Descrição">

              <b-tag :type="props.row | statusType">{{ props.row.descricao ? props.row.descricao : 'Sem Descrição' }}</b-tag>
              </b-table-column
            >
            <b-table-column field="Valor">
              R$ {{ props.row.servico.base_calculo | money }}</b-table-column
            >
            <b-table-column field="Socios">
              <div v-for="(socio, index) in props.row.socios" :key="index">
                {{ socio.socio }} - {{ socio.valor }}
                <br /></div
            ></b-table-column>
            <b-table-column field="Motico Cancelamento">
              {{ props.row.motivo_cancelado }}</b-table-column
            >
<!-- 
            <b-table-column field="Criou">
              <span v-if="props.row.userin"> {{ props.row.userin.nome_completo }}</span>
            </b-table-column>
            <b-table-column field="Atualizou">
              <span v-if="props.row.userup"> {{ props.row.userup.nome_completo }}</span>
            </b-table-column>
            <b-table-column field="Deletou">
              <span v-if="props.row.userdel">
                {{ props.row.userdel.nome_completo }}</span
              >
            </b-table-column> -->

            <b-table-column field="Ações">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    <v-icon> mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <Lynx-Button
                      icon="Eye"
                      icon-size="3"
                      size="small"
                      @click.native="openFile(props.row.arquivo.id)"
                    />
                    <!-- <v-list-item-title>{{ item.title }}</v-list-item-title> -->
                  </v-list-item>
                  <v-list-item  v-if="hasRole('super-admin')">
                    <Lynx-Button
                      v-show="!props.row.data_estorno"
                      icon="Trash"
                      color="error-base"
                      icon-size="3"
                      size="small"
                      @click.native="showModal('delete', props.row)"
                    />
                    <!-- <v-list-item-title>{{ item.title }}</v-list-item-title> -->
                  </v-list-item>
                  <v-list-item>
                    <Lynx-Button
                      v-show="!props.row.data_deleted_at"
                      icon="Edit"
                      color="primary-900"
                      icon-size="3"
                      size="small"
                      @click.native="showModal('update', props.row)"
                    />
                    <!-- <v-list-item-title>{{ item.title }}</v-list-item-title> -->
                  </v-list-item>
                  <v-list-item>
                    <Lynx-Button
                      v-show="!props.row.data_estorno"
                      icon="Cross"
                      color="warning-base"
                      icon-size="3"
                      size="small"
                      @click.native="showModal('cancelar', props.row)"
                    />
                    <!-- <v-list-item-title>{{ item.title }}</v-list-item-title> -->
                  </v-list-item>
                  <v-list-item>
                  <Lynx-Button
              v-if="hasRole('super-admin')"
              icon="User"
                      color="success-base"
                      icon-size="3"
                      size="small"
              @click.native="open(props.row)"
            />
         
            </v-list-item>
                </v-list>
              </v-menu>
            </b-table-column>
          </template>
        </b-table>

      </div>

      <!-- <b-modal :active.sync="guiasModal" @close="closeNotafiscalModal" v-if="guiasModal">
      <GerenciamentoNotafiscalDetails :current-empresa="currentEmpresa" @estornar="fetchNotafiscal"/>
    </b-modal> -->
    </v-card>
    <v-snackbar
              v-if="nota_fical_logs"
              color="primary"
              shaped
              v-model="logs"
              :vertical="false"
            >
              <span v-if="nota_fical_logs.userin" style="font-size: 15px"
                >Criou: {{ nota_fical_logs.userin.nome_completo }}
                <br>
              </span>
         
              <span v-if="nota_fical_logs.userup" style="font-size: 15px"
                >Atualizou: {{ nota_fical_logs.userup.nome_completo }}
                <br>
              </span>
             
              <span v-if="nota_fical_logs.userdel" style="font-size: 15px"
                >deletou: {{ nota_fical_logs.userdel.nome_completo }}
                <br />
              </span>
           
              <span v-if="!nota_fical_logs.userdel && !nota_fical_logs.userin && !nota_fical_logs.userup" style="font-size: 15px"
                >sem logs
                <br />
              </span>
           
              <!-- <span style="font-size: 15px; margin-top: 10px;">DELETOU: {{ user_up.toUpperCase() }} </span> -->

              <template v-slot:action="{ attrs }">
                <v-btn color="error" icon v-bind="attrs" @click.native="hide()">
                  <v-icon large> mdi-close </v-icon>
                </v-btn>
              </template>
            </v-snackbar>
    <b-modal :active.sync="modal.eye2" >
     <v-card
        elevation="10"
    
        class="p-3"
      >
        <div v-if="modal.tipo == 'delete'">
          <Lynx-Title text="Deletar" />

          <div>Tem certeza que desaja deletar essa nota fiscal?</div>
          <div class="w-full flex justify-end items-start">
            <Lynx-Button
              icon="Trash"
              color="error-base"
              icon-size="4"
              size="small"
              @click.native="deleteNotafiscal()"
            />
          </div>
        </div>
        <div v-if="modal.tipo == 'cancelar'">
          <Lynx-Title text="Motivo Cancelar" />

          <Lynx-Textarea
            placeholder="Digite o motivo para cancelar"
            v-model="formdel.motivo_cancelado"
          />
          <div class="w-full flex justify-end items-start">
            <Lynx-Button
              icon="Cross"
              color="warning-base"
              icon-size="4"
              size="small"
              :disabled="!formdel.motivo_cancelado"
              @click.native="deleteNotafiscal()"
            />
          </div>
        </div>
        </v-card>
        </b-modal>
   
    <b-modal :active.sync="modal.eye" full-screen>
      <div
        class="flex flex-col bg-neutral-400 shadow p-3 flex flex-col rounded h-auto"
      >
        <div class="flex justify-between items-start">
          <Lynx-Button
            icon="ArrowLeft"
            @click.native="hideModal()"
            class="mt-2"
          >
          </Lynx-Button>
        </div>
      </div>

        <v-divider class="mt-2" style="background-color: black;"></v-divider>
      <div class="">
        <espelhoNotaFiscal @update="listar_enf()" @hidemodel="hideModal" ></espelhoNotaFiscal>
      </div>
      <!-- <v-card
        elevation="10"
    
        class="p-3"
      >
        <div v-if="modal.tipo == 'delete'">
          <Lynx-Title text="Deletar" />

          <div>Tem certeza que desaja deletar essa nota fiscal?</div>
          <div class="w-full flex justify-end items-start">
            <Lynx-Button
              icon="Trash"
              color="error-base"
              icon-size="4"
              size="small"
              @click.native="deleteNotafiscal()"
            />
          </div>
        </div>
        <div v-if="modal.tipo == 'cancelar'">
          <Lynx-Title text="Motivo Cancelar" />

          <Lynx-Textarea
            placeholder="Digite o motivo para cancelar"
            v-model="formdel.motivo_cancelado"
          />
          <div class="w-full flex justify-end items-start">
            <Lynx-Button
              icon="Cross"
              color="warning-base"
              icon-size="4"
              size="small"
              :disabled="!formdel.motivo_cancelado"
              @click.native="deleteNotafiscal()"
            />
          </div>
        </div>

        <div v-if="modal.tipo == 'update'">
          <Lynx-Title text="Atualizar Nota Fiscal" />
          <div class="mb-4 flex w-full gap-2">
            <label class="flex flex-col w-1/6" style="width: 1px">
              <Lynx-Label label="ID" />

              <Lynx-Input disabled :value="getEmpresa.id" />
            </label>
            <label class="flex flex-col w-3/6">
              <Lynx-Label label="EMPRESA" />

              <Lynx-Input disabled :value="getEmpresa.razao_social" />
            </label>
            <label class="w-2/6">
              <Lynx-Label label="Regime tributario" />

              <Lynx-Input
                disabled
                type="text"
                :value="getEmpresa.regime_tributario"
              />
            </label>
          </div>
          <div v-for="(socio, index) in formup.tags.socios" :key="index">
            <div class="mb-8 items-start flex gap-2">
              <label class="flex flex-col w-5/6">
                <Lynx-Label label="Socio" />
                <Lynx-Input disabled :value="socio.socio" />
              </label>
              <label class="flex flex-col w-1/6">
                <Lynx-Label label="Valor" />
                <InputMoney
                  required
                  v-model="socio.valor"
                  @input="(money) => (socio.valor = money)"
                ></InputMoney>
              </label>
            </div>
          </div>
          <div class="mb-4 flex w-full gap-2">
            <label class="flex-col w-4/6">
              <Lynx-Label label="Tomador" />

              <Lynx-Input type="text" v-model="formup.tags.tomador" />
            </label>
            <label class="flex-col w-2/6">
              <Lynx-Label label="CNPJ/CPF Tomador" />

              <Lynx-Input type="text" v-model="formup.tags.cnpj_tomador" />
            </label>
          </div>
          <div class="mb-4 items-start grid grid-cols-4 gap-8">
            <label class="">
              <Lynx-Label label="Date Emissão" />

              <Lynx-Input type="date" v-model="formup.tags.emissao" />
            </label>
            <label class="">
              <Lynx-Label label="Descricao" />

              <b-select v-model="formup.tags.descricao">
                <option :value="null" disabled selected>
                  Selecione a descrição
                </option>
                <option value="Ativa">Ativa</option>
                <option value="Cancelado">Cancelado</option>
                <option value="Processo de Cancelamento">
                  Processo de Cancelamento
                </option>
              </b-select>
            </label>
            <label class=" ">
              <Lynx-Label label="Nº NF" />

              <Lynx-Input type="text" v-model="formup.tags.numero" />
            </label>

            <label class=" ">
              <Lynx-Label label="Valor" />

              <InputMoney
                required
                v-model="nota_fiscal_valor"
                @input="(money) => (nota_fiscal_valor = money)"
              ></InputMoney>
            </label>
          </div>

          <div
            class="mb-1 grid grid-cols-2 items-start"
            v-if="
              getEmpresa.regime_tributario !== 'Simples Nacional' &&
              this.baseCalculo > 215.06
            "
          >
            <b-select class="w-2/3" v-model="simulador">
              <option :value="null" disabled selected>
                Selecione o sumulador
              </option>
              <option value="1">Orgão Publico IR 1,2%</option>
              <option value="2">Orgão Publico IR 1,5%</option>
              <option value="3">Orgão Público IR 4,8%</option>
              <option value="4">Presumido</option>
              <option value="5">Presumido com IR 1,2%</option>
              <option value="6">Presumido com IR 4,8%</option>
            </b-select>
            <div>
              <table v-if="simulador" style="font-size: small">
                <thead>
                  <tr>
                    <th>BASE DE CÁLCULO</th>
                    <th></th>
                    <th>R$ {{ this.baseCalculo | money }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in tabela[simulador]" :key="index">
                    <td>{{ item.descricao }}</td>
                    <td>{{ item.porcentagem }}%</td>
                    <td>R$ {{ calcularImposto(item).replace(".", ",") }}</td>
                  </tr>

                  <tr>
                    <td>Valor Líquido</td>
                    <td></td>
                    <td>R$ {{ calcularTotalImpostos().replace(".", ",") }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="w-full flex justify-end items-start">
            <Lynx-Button
              icon="Save"
              color="primary-500"
              icon-size="4"
              size="small"
              @click.native="updateNotafiscal()"
            />
          </div>
        </div>
        <div v-if="modal.tipo == 'criar'">
          <Lynx-Title text="Criar Nota Fiscal" />
    
          <div class="mb-4 flex w-full gap-2">
            <label class="flex flex-col w-1/6" style="width: 1px">
              <Lynx-Label label="ID" />

              <Lynx-Input disabled :value="getEmpresa.id" />
            </label>
            <label class="flex flex-col w-3/6">
              <Lynx-Label label="EMPRESA" />

              <Lynx-Input disabled :value="getEmpresa.razao_social" />
            </label>
            <label class="w-2/6">
              <Lynx-Label label="Regime tributario" />

              <Lynx-Input
                disabled
                type="text"
                :value="getEmpresa.regime_tributario"
              />
            </label>
          </div>
          <div v-for="(socio, index) in formin.tags.socios" :key="index">
            <div class="mb-8 items-start flex gap-2">
              <label class="flex flex-col w-5/6">
                <Lynx-Label label="Socio" />
                <Lynx-Input disabled :value="socio.socio" />
              </label>
              <label class="flex flex-col w-1/6">
                <Lynx-Label label="Valor" />
                <InputMoney
                  required
                  v-model="socio.valor"
                  @input="(money) => (socio.valor = money)"
                ></InputMoney>
              </label>
            </div>
          </div>
          <div class="mb-4 flex w-full gap-2">
            <label class="flex-col w-4/6">
              <Lynx-Label label="Tomador" />

              <Lynx-Input type="text" v-model="formin.tags.tomador" />
            </label>
            <label class="flex-col w-2/6">
              <Lynx-Label label="CNPJ/CPF Tomador" />

              <Lynx-Input type="text" v-model="formin.tags.cnpj_tomador" />
            </label>
          </div>
          <div class="mb-8 items-start grid grid-cols-4 gap-2">
            <label class=" ">
              <Lynx-Label label="Date Emissão" />

              <Lynx-Input type="date" v-model="formin.tags.emissao" />
            </label>
            <label class="flex-col">
              <Lynx-Label label="Descricao" />

              <b-select v-model="formin.tags.descricao">
                <option :value="null" disabled selected>
                  Selecione a descrição
                </option>
                <option value="Ativa">Ativa</option>
                <option value="Cancelado">Cancelado</option>
                <option value="Processo de Cancelamento">
                  Processo de Cancelamento
                </option>
              </b-select>
            </label>

            <label class=" ">
              <Lynx-Label label="Nº NF" />

              <Lynx-Input type="text" v-model="formin.tags.numero" />
            </label>
            <label class=" ">
              <Lynx-Label label="Valor" />

              <InputMoney
                required
                v-model="nota_fiscal_valor"
                @input="(money) => (nota_fiscal_valor = money)"
              ></InputMoney>
            </label>
          </div>
          <Input-File class="mb-4" text="Adicionar Arquivo" ref="fileInput" />

          <div
            class="mb-1 grid grid-cols-2 items-start"
            v-if="
              getEmpresa.regime_tributario !== 'Simples Nacional' &&
              this.baseCalculo > 215.06
            "
          >
            <b-select
              @input="baseCalculo = nota_fiscal_valor"
              class="w-2/3 mb-3"
              v-model="simulador"
            >
              <option :value="null" disabled selected>
                Selecione a descrição
              </option>
              <option value="1">Orgão Publico IR 1,2%</option>
              <option value="2">Orgão Publico IR 1,5%</option>
              <option value="3">Orgão Público IR 4,8%</option>
              <option value="4">Presumido</option>
              <option value="5">Presumido com IR 1,2%</option>
              <option value="6">Presumido com IR 4,8%</option>
            </b-select>

            <table v-if="simulador" class="" style="font-size: small">
              <thead>
                <tr>
                  <th>BASE DE CÁLCULO</th>
                  <th></th>
                  <th>R$ {{ this.baseCalculo | money }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in tabela[simulador]" :key="index">
                  <td>{{ item.descricao }}</td>
                  <td>{{ item.porcentagem }}%</td>
                  <td>R$ {{ calcularImposto(item).replace(".", ",") }}</td>
                </tr>

                <tr>
                  <td>Valor Líquido</td>
                  <td></td>
                  <td>R$ {{ calcularTotalImpostos().replace(".", ",") }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="w-full flex justify-end items-start">
            <Lynx-Button
              icon="Save"
              color="primary-500"
              icon-size="4"
              size="small"
              @click.native="createNotafiscal()"
            />
          </div>
        </div>
      </v-card> -->
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import InputFile from "@/components/helpers/InputFile";

import { formatBrToEn, formatDateTimeToBr } from "@/utils/momentHelpers";
import { monthNames } from "@/utils/utils";
import LynxTextarea from "@/components/helpers/Textarea";
import InputMoney from "@/components/helpers/InputMoney";
import espelhoNotaFiscal from "@/views/localtrabalho/espelhoNotaFiscal";
// import GerenciamentoNotafiscalDetails from '@/views/guias/GerenciamentoNotafiscalDetails'
import { hasPermission } from "@/utils/can";
import { carteirasRequest } from "../../services/requests/carteiras";
import { formatEnToBr } from "@/utils/momentHelpers";
import moment from "moment";
import {empresasUpdateRequest} from "@/services/requests/empresas";
// import bus from "../../services/bus";
import { hasRole } from "@/utils/can";
export default {
  name: "GerenciamentoNotafiscal",
  components: { LynxTextarea, InputMoney, InputFile, espelhoNotaFiscal },
  data() {
    return {
      nota_fical_logs:{},
      logs:false,
      emite_nf:0,
      items: [
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me 2" },
      ],
      tabela: {
        1: [
          { descricao: "PIS", porcentagem: 0 },
          { descricao: "COFINS", porcentagem: 0 },
          { descricao: "CSLL", porcentagem: 0 },
          { descricao: "IR", porcentagem: 1.2 },
        ],
        2: [
          { descricao: "PIS", porcentagem: 0 },
          { descricao: "COFINS", porcentagem: 0 },
          { descricao: "CSLL", porcentagem: 0 },
          { descricao: "IR", porcentagem: 1.5 },
        ],
        3: [
          { descricao: "PIS", porcentagem: 0 },
          { descricao: "COFINS", porcentagem: 0 },
          { descricao: "CSLL", porcentagem: 0 },
          { descricao: "IR", porcentagem: 4.8 },
        ],
        4: [
          { descricao: "PIS", porcentagem: 0.65 },
          { descricao: "COFINS", porcentagem: 3 },
          { descricao: "CSLL", porcentagem: 1 },
          { descricao: "IR", porcentagem: 1.5 },
        ],
        5: [
          { descricao: "PIS", porcentagem: 0.65 },
          { descricao: "COFINS", porcentagem: 3 },
          { descricao: "CSLL", porcentagem: 1 },
          { descricao: "IR", porcentagem: 1.2 },
        ],
        6: [
          { descricao: "PIS", porcentagem: 0.65 },
          { descricao: "COFINS", porcentagem: 3 },
          { descricao: "CSLL", porcentagem: 1 },
          { descricao: "IR", porcentagem: 4.8 },
        ],
      },
      modal: { tipo: "", eye: false,eye2: false },

      formdel: {
        motivo_cancelado: null,
        notasfiscais_id: null,
        usuario_id: null,
      },
 
      simulador: null,
      monthNames,
      dataCompetencia: null,
      dataEnvio: null,
      loading: false,
      carteiras: [],
      carteira_filter: "todas",
      // nota_fiscal_valor: 0,
      socios: [],

      columns: [
        // {
        //   field: 'empresas_id',
        //   label: 'Empresa',
        // },
        // {
        //   field: 'tipo',
        //   label: 'Tipo',
        // },
        {
          field: "tomador.numero_nota_fiscal",
          label: "NºNF",
          sortable:true,
  
        
        },
        {
          field: "created_at",
          label: "Criação",
        
        },
        {
          field: "tomadores_id",
          label: "Tomador",
        },
       
        {
          field: "emissao",
          label: "Emissão",
        },
        {
          field: "data_competencia",
          label: "Data Competencia",
        },

        {
          field: "descricao",
          label: "Descrição",
        },
        {
          field: "servico.base_calculo",
          label: "Valor",
        },
        {
          field: "socios",
          label: "Socios",
        },

        {
          field: "motivo_cancelado",
          label: "Motivo Cancelamento",
        },
        // {
        //   field: "in",
        //   label: "Criou",
        // },
        // {
        //   field: "up",
        //   label: "Atualizou",
        // },
        // {
        //   field: "del",
        //   label: "Deletou",
        // },
        {
          label: "Ações",
        },
      ],
      notasfiscais: [],
      currentNotafiscal: {},
      guiasModal: false,
      filter_status: null,
      uploadReport: {},
      uploadReportInterval: null,
      status_notasfiscais: [
        { id: 0, status: "Todas" },
        { id: 1, status: "Enviado" },
        { id: 6, status: "Não enviado" },
        { id: 2, status: "Com Erro" },
        { id: 3, status: "Pendente Financeiro" },
        { id: 4, status: "Pendente RH" },
        { id: 5, status: "Pendente Contabilidade" },
      ],
    };
  },
  filters: {
    formatEnToBr,
    money: (value) => {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    statusType: (val) => {
      if (val.descricao === "Ativa") {
        return "is-success";
      }
      if (val.descricao === "Cancelado" ) {
        return "is-dark";
      }
      if (val.descricao === "Processo de Cancelamento") {
        return "is-warning";
      }
 
    
      return "default";
    },
  },
  computed: {
    ...mapGetters(["getCompetenciaDate", "getEmpresa", "getUser"]),
    // ...mapActions(["setEmpresa"]),
    dataCompetenciaComputed() {
      return this.dataCompetencia
        ? formatBrToEn(this.dataCompetencia)
        : this.getCompetenciaDate;
    },
    lista_enf() {
      return this.$store.state.enf.lista_enf;
    },

    valor_total() {
      let valor_total = 0;
      if(this.notasfiscais[0]){
      this.notasfiscais.forEach((element) => {
        if (!element.motivo_cancelado && element.descricao != 'Processo de Cancelamento' && element.descricao != 'Cancelado') {
          valor_total += element.servico.base_calculo;
        }
      });
    }

      return valor_total;
    },
  },
  watch: {
  
  
    // nota_fiscal_valor() {
    //   this.baseCalculo = this.nota_fiscal_valor;
    // },
  },
  created(){
    console.log(this.getEmpresa.emite_nf)
   this.emite_nf = this.getEmpresa.emite_nf
  },
  mounted() {
    // this.fetchCarteiras()
    this.listar_enf();
    // this.fetchUploadReport()
    // this.uploadReportInterval = setInterval(() => this.fetchUploadReport(), 15000)
  },
  destroyed() {
    clearInterval(this.uploadReportInterval);
  },
  methods: {
    hasRole,
  async  emitir_nf(){
     
      this.loading = true;
    await  empresasUpdateRequest(this.getEmpresa.id, {emite_nf:this.emite_nf})
        .then(() => {
          this.$snack.success(this.emite_nf ?'Empresa Emite Nf':'Empresa Não Emite Nf')
        this.$emit('updated')

        // this.setEmpresa(res.data.data);
        })
        .catch(() => this.$snack.error('Não foi possivel aterar as informações'))
        .finally(() =>   this.loading = false)

    },
    moment,
    hasPermission,
    fetchCarteiras() {
      carteirasRequest()
        .then((response) => {
          const { data } = response.data;
          this.carteiras = data.filter(
            (carteira) => carteira.setor === "contabilidade"
          );
        })
        .catch((error) => this.$snack.error(error.response.data.message));
    },
 
    async listar_enf() {
     
      // this.$store.dispatch("carteira/listar_carteiras");
      this.loading = true
      await this.$store.dispatch("enf/listar_enfs_empresa",this.getEmpresa.id);
      this.$store.dispatch("configEmpresa/atualizar", "");
      this.loading = false
      this.notasfiscais = this.lista_enf
    },

    filter_competecia(){
      let filter_competecia= this.lista_enf

      this.notasfiscais = filter_competecia.filter(item => {
  if (item.tomador && item.tomador.data_emissao) {
    const dataCompetenciaItem = moment.utc(item.tomador.data_emissao).format('YYYY-MM');

    const dataCompetenciaThis = moment(this.dataCompetencia).format('YYYY-MM');
// console.log(dataCompetenciaThis)
// console.log(dataCompetenciaItem)

    return dataCompetenciaItem === dataCompetenciaThis;
  }

  return false;
});

      
    },

    openFile(fileId) {
      window.open(
        `${process.env.VUE_APP_API_URL}/arquivos/${fileId}/open?token=${this.$store.getters.getToken}`
      );
    },

    hideModal() {
      this.modal.eye = false;
      // this.listar_enf()
      this.$store.dispatch("configEmpresa/atualizar", "");

    },
    

   async showModal(tipo, notafiscal) {
      this.modal.tipo = tipo;
      if (tipo == "delete" || tipo == "cancelar") {
        this.formdel.notasfiscais_id = notafiscal.id;
        this.formdel.user_del = this.getUser.id;
        this.formdel.motivo_cancelado = null;
      this.modal.eye2 = true;
      }
      else if (tipo == "update") {
       
       await this.$store.dispatch("configEmpresa/atualizar", notafiscal);
        this.modal.eye = true;


   
       
      } else {
      this.modal.eye = true;
     
      }

    },
    async deleteNotafiscal() {
      this.loading = true;

    if(this.modal.tipo == 'cancelar'){
   await this.$store
        .dispatch("enf/cancelar_enf", this.formdel)
        this.listar_enf();

        

    }else{
           await this.$store
        .dispatch("enf/delete_enf", this.formdel)
              this.notasfiscais = this.notasfiscais.filter((notafiscal) => {
          return notafiscal.id !== this.formdel.notasfiscais_id;
        });

    }
      this.loading = false;
   
      this.modal.eye = false;
    },
  
  open(val) {
      this.nota_fical_logs = val ;
      this.logs = true;
    },

    hide(){
      this.logs = false;
    },
    reletorio() {
      window.open(
        `${process.env.VUE_APP_API_URL}/relatorio/espelho-notafiscal` +
          `?token=${this.$store.getters.getToken}&empresa_id=${this.getEmpresa.id}`,
        "_blank"
      );
      // window.open('http://localhost:8000/notasfiscais/relatorio/?tipo=NOTA_FISCAL','_brank')
    },
    calcularImposto(item) {
      const valorImposto = (item.porcentagem / 100) * this.baseCalculo;
      return valorImposto.toFixed(2);
    },
    calcularTotalImpostos() {
      let totalImpostos = 0;
      for (const item of this.tabela[this.simulador]) {
        totalImpostos += parseFloat(this.calcularImposto(item));
      }
      return (this.baseCalculo - totalImpostos).toFixed(2);
    },
  },
};
</script>

<style scoped>
/* Estilize a tabela */
table {
  border-collapse: collapse; /* Mescla as bordas das células */
  width: 100%; /* Largura da tabela */
}

/* Estilize as células da tabela */
table th,
table td {
  border: 1px solid #dddddd; /* Adiciona borda a todas as células */
  padding: 8px; /* Espaçamento interno das células */
  text-align: left; /* Alinhamento do texto à esquerda */
}

/* Estilize as células do cabeçalho da tabela */
table th {
  background-color: #f2f2f2; /* Cor de fundo do cabeçalho */
  font-weight: bold; /* Texto em negrito no cabeçalho */
}

/* Estilize as células da tabela (linhas pares) com fundo cinza claro */
table tr:nth-child(even) {
  background-color: #f2f2f2;
}

/* Estilize as células da tabela (linhas ímpares) com fundo branco */
table tr:nth-child(odd) {
  background-color: #ffffff;
}

/* Reduza o espaçamento vertical entre as linhas */
table tr {
  line-height: 1.5; /* Ajuste o valor conforme necessário */
}
/* .table-container {
  overflow-x: auto;
  width: 100%;
}

.table-scroll {
  width: 120%; 
} */
</style>
